
import { defineComponent, h } from "vue";

export default defineComponent({
  name: "BaseButton",
  props: {
    tag: {
      type: String,
      default: "button",
    },
    href: String,
  },
  setup(props, context) {
    return () =>
      h(
        props.tag,
        { class: "button", href: props.href },
        typeof context.slots.default === "function"
          ? context.slots.default()
          : undefined
      );
  },
});
